import Cookies from 'js-cookie';
import { init, track } from '@amplitude/analytics-browser';

const getSubdomainName = () => {
  const subdomainParts = window.location.hostname.split('.');

  if (subdomainParts.length > 2) {
    subdomainParts.shift();
  }

  return `.${subdomainParts.join('.')}`;
};

const getVisitorId = (): string => {
  const COOKIE_NAME = 'ks_visitor_id';
  const visitorId = Cookies.get(COOKIE_NAME);

  if (visitorId) {
    return visitorId;
  }

  const COOKIE_DOMAIN = getSubdomainName();

  const newUdid = 'randomUUID' in crypto ? crypto.randomUUID() : '';

  Cookies.set(COOKIE_NAME, newUdid, {
    expires: 365,
    domain: COOKIE_DOMAIN,
  });

  return newUdid;
};

const AMPLITUDE_API_KEY = window.amplitudeApiKey ?? '';
const searchParams = new URLSearchParams(window.location.search);
const urlUserId = searchParams.get('mp_user_id');
const urlDeviceId = searchParams.get('udid');
const userId = urlUserId ?? getVisitorId();
const deviceId = urlDeviceId ?? undefined;

export const initAmplitude = () => {
  if (AMPLITUDE_API_KEY) {
    init(AMPLITUDE_API_KEY, {
      userId,
      deviceId,
      autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
        frustrationInteractions: false,
        networkTracking: false,
        webVitals: false,
      },
    });
  }
};

type EventProperties = Record<string, string | number | string[] | number[]>;

export const sendAmplitudeEvent = (
  eventName: string,
  eventProperties: EventProperties = {},
) => {
  if (AMPLITUDE_API_KEY) {
    const properties: EventProperties = {
      ...eventProperties,
      event_properties__user_id: userId,
    };

    if (deviceId) {
      properties.event_properties__device_id = deviceId;
    }

    track(eventName, properties);
  }
};
